<template>
  <v-dialog v-model="visible" persistent max-width="900px" scrollable>
    <v-card :loading="loading">
      <v-card-title>
        <span class="headline">{{ $t("modal.editComplianceSettings.title") }}</span>
      </v-card-title>
      <v-card-text>
        <p class="text-h6">Screening Data Sets</p>
        <p>
          Configure which sanction lists to include in initial and ongoing case screening.
        </p>

        <v-container>
          <v-row no-gutters>
            <v-col cols="8" class="text-h6 font-weight-bold mb-4">
              Name
            </v-col>
            <v-col cols="2" class="text-h6 font-weight-bold">Country</v-col>
            <v-col cols="2" class="text-h6 font-weight-bold">Enabled</v-col>
          </v-row>
          <template v-for="(source, index) in sourceList">
            <v-row :key="index" no-gutters class="mt-2">
              <v-col cols="8" class="text-subtitle-1 font-weight-bold">
                <v-icon small>mdi-database</v-icon>
                {{ source.name }}
              </v-col>
              <v-col cols="2" class="font-weight-medium">
                {{ source.country }}
              </v-col>
              <v-col cols="2">
                <v-switch
                  class="pa-0 ma-0"
                  v-model="editAccount.accountSettings.lists"
                  :value="source.id"
                  multiple
                  hide-details
                  dense
                  inset
                   />
              </v-col>
              <v-col cols="7">
                {{ source.summary }}
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="onCancel">{{ $t("label.cancel") }}</v-btn>
        <v-btn color="primary" dark @click="handleSubmit" :loading="loading">{{
          $t("label.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import source_list from "../../assets/source_list.json";
export default {
  name: "EditComplianceSources",
  data() {
    return {
      loading: false,
      sourceList: this.sortSanctionsByCountry(source_list),
      editAccount: {
        ...this.account,
        accountSettings: this.account.accountSettings ? this.account.accountSettings : {},
      },
    };
  },
  props: {
    account: {},
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    account: {
      immediate: true,
      handler(val) {
        this.editAccount = {
          ...val,
          accountSettings: val.accountSettings ? val.accountSettings : {},
        };
      },
    },
  },
  methods: {
    ...mapActions(["updateAccount", "setGlobalAlert"]),
    handleSubmit() {
      this.loading = true;
      this.updateAccount(this.editAccount)
        .then(() => {
          this.setGlobalAlert({
            alert: true,
            color: "green",
            alertMessage: "Compliance Settings Updated",
          });
          this.$emit("onCancelled");
        })
        .catch((err) => {
          console.log("updateAccount.settings error", err);
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertMessage: this.$t("error.general.unhandled"),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCancel() {
      this.loading = false;
      this.$emit("onCancelled");
    },
    sortSanctionsByCountry(sanctions) {
      return sanctions.sort((a, b) => {
        const countryA = a.country || ""; // Treat empty country as '' for PEP
        const countryB = b.country || "";

        // Define priority order
        const priority = {
          US: 1,
          EU: 2,
          "": 4, // PEP (empty country) goes last
        };

        // Get priorities, default to 3 for other countries
        const priorityA = priority[countryA] || 3;
        const priorityB = priority[countryB] || 3;

        // Compare priorities
        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        // If priorities are equal (e.g., both are other countries), sort alphabetically
        if (priorityA === 3 && priorityB === 3) {
          return countryA.localeCompare(countryB);
        }

        // Maintain original order for same priority (e.g., US or EU entries)
        return 0;
      });
    },
  },
  created: function () {},
};
</script>
